/* global axios */
import ApiClient from './ApiClient';

// Conexoes com o Google Agenda (spec 010): por usuario ou por profissional.
class GoogleCalendarAPI extends ApiClient {
  constructor() {
    super('google_calendar', { accountScoped: true });
  }

  getConnections(params = {}) {
    return axios.get(`${this.url}/connections`, { params });
  }

  // Devolve { url } do consentimento do Google
  // calendarList: consentimento incremental do seletor de agendas
  authorize({ practitionerId, calendarList } = {}) {
    return axios.post(`${this.url}/authorizations`, {
      ...(practitionerId ? { practitioner_id: practitionerId } : {}),
      ...(calendarList ? { calendar_list: true } : {}),
    });
  }

  getCalendars(id) {
    return axios.get(`${this.url}/connections/${id}/calendars`);
  }

  saveCalendars(id, { calendarId, readCalendarIds }) {
    return axios.patch(`${this.url}/connections/${id}/calendars`, {
      calendar_id: calendarId,
      read_calendar_ids: readCalendarIds,
    });
  }

  // Opcao da empresa: evento de cartao/atividade vai para o 'assignee' (padrao) ou o 'creator'
  updateSettings({ eventOwner }) {
    return axios.patch(`${this.url}/settings`, { event_owner: eventOwner });
  }

  updateConnection(id, { syncTasks, showEventTitles }) {
    return axios.patch(`${this.url}/connections/${id}`, {
      sync_tasks: syncTasks,
      show_event_titles: showEventTitles,
    });
  }

  disconnect(id) {
    return axios.delete(`${this.url}/connections/${id}`);
  }
}

export default new GoogleCalendarAPI();
